import { render } from "./InstructorDetails.vue?vue&type=template&id=f56acf74&scoped=true"
import script from "./InstructorDetails.vue?vue&type=script&lang=js"
export * from "./InstructorDetails.vue?vue&type=script&lang=js"

import "./InstructorDetails.vue?vue&type=style&index=0&id=f56acf74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56acf74"]])

export default __exports__